import { render, staticRenderFns } from "./NovaPoshtaParams.vue?vue&type=template&id=64e6baaf&scoped=true"
import script from "./NovaPoshtaParams.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6baaf",
  null
  
)

export default component.exports